import { Component, inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {
  Item,
  ItemActionResult,
  ItemView,
  ItemViewProviderDirective,
  ServerItemAction
} from '@ntap/core';
import { Observable, Subject, switchMap, tap } from 'rxjs';

@Component({
  selector: 'app-zakljucenje-predmeta-action',
  templateUrl: './zakljucenje-predmeta-action.component.html'
})
export class ZakljucenjePredmetaActionComponent
  extends ServerItemAction
  implements OnInit
{
  itemViewProvider: ItemViewProviderDirective<ItemView> = inject(
    ItemViewProviderDirective
  );
  formBuilder: FormBuilder = inject(FormBuilder);
  razlogFg: FormGroup;
  submitSubject = new Subject<boolean>();
  showDialog = false;

  ngOnInit(): void {
    this.razlogFg = this.formBuilder.group({
      razlog: ['', Validators.required]
    });
  }

  confirmRejection() {
    this.showDialog = false;
    this.submitSubject.next(true);
  }

  override executeAction(event: any): void {
    this.showDialog = true;
    super.executeAction(event);
  }

  protected override doExecuteWithItem(
    item: Item
  ): Observable<ItemActionResult> {
    return this.submitSubject.pipe(
      switchMap(() => {
        const razlog = this.razlogFg.get('razlog');
        const itemWithReason = Object.assign({}, item, {
          'seup~predmet~napomena_o_zakljucenju': razlog?.value || null
        });
        return super.doExecuteWithItem(itemWithReason).pipe(
          tap(() => {
            this.window.close();
          })
        );
      })
    );
  }

  closeDialog() {
    this.showDialog = false;
  }
}
